import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const HeroSection = () => {
  return (
    <section className="relative bg-gradient-to-br from-primary/5 via-background to-accent/5 py-16 lg:py-24 overflow-hidden">
      <div className="absolute inset-0 bg-grid-pattern opacity-5"></div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="inline-flex items-center space-x-2 bg-primary/10 text-primary px-4 py-2 rounded-full text-sm font-medium">
              <Icon name="Sparkles" size={16} />
              <span>AI-Powered Customer Engagement</span>
            </div>
            
            <h1 className="text-4xl lg:text-5xl xl:text-6xl font-bold text-text-primary leading-tight">
              Transform Customer Service with{' '}
              <span className="text-primary">AI Chatbots</span>
            </h1>
            
            <p className="text-lg text-text-secondary leading-relaxed">
              Deploy intelligent chatbots that understand context, learn from interactions, and provide 24/7 support. Reduce response times by 90% while maintaining personalized customer experiences at scale.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <Link to="/contact">
                <Button 
                  variant="default" 
                  size="lg" 
                  iconName="Calendar" 
                  iconPosition="left"
                  className="w-full sm:w-auto"
                >
                  Book Free AI Audit
                </Button>
              </Link>
              <Button 
                variant="outline" 
                size="lg" 
                iconName="Play" 
                iconPosition="left"
                className="w-full sm:w-auto"
              >
                Watch Demo
              </Button>
            </div>
            
            <div className="flex items-center space-x-8 pt-4">
              <div className="flex items-center space-x-2">
                <Icon name="CheckCircle2" size={20} className="text-success" />
                <span className="text-sm text-text-secondary">No coding required</span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="CheckCircle2" size={20} className="text-success" />
                <span className="text-sm text-text-secondary">Setup in 48 hours</span>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <div className="relative bg-card rounded-2xl shadow-2xl p-6 border border-border">
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center space-x-2">
                  <div className="w-3 h-3 rounded-full bg-error"></div>
                  <div className="w-3 h-3 rounded-full bg-warning"></div>
                  <div className="w-3 h-3 rounded-full bg-success"></div>
                </div>
                <span className="text-xs text-text-secondary">Live Demo</span>
              </div>
              
              <div className="space-y-4 h-96 overflow-y-auto">
                <div className="flex items-start space-x-3">
                  <div className="flex-shrink-0 w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center">
                    <Icon name="Bot" size={16} className="text-primary" />
                  </div>
                  <div className="flex-1 bg-surface rounded-lg p-3">
                    <p className="text-sm text-text-primary">
                      Hello! I'm your AI assistant. How can I help you today?
                    </p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3 justify-end">
                  <div className="flex-1 bg-primary rounded-lg p-3 max-w-xs">
                    <p className="text-sm text-primary-foreground">
                      I need help with my order status
                    </p>
                  </div>
                  <div className="flex-shrink-0 w-8 h-8 rounded-full bg-accent/10 flex items-center justify-center">
                    <Icon name="User" size={16} className="text-accent" />
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <div className="flex-shrink-0 w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center">
                    <Icon name="Bot" size={16} className="text-primary" />
                  </div>
                  <div className="flex-1 bg-surface rounded-lg p-3">
                    <p className="text-sm text-text-primary">
                      I'd be happy to help! Could you please provide your order number?
                    </p>
                  </div>
                </div>
                
                <div className="flex items-center space-x-2 text-xs text-text-secondary px-3">
                  <Icon name="Sparkles" size={12} />
                  <span>AI is typing...</span>
                </div>
              </div>
              
              <div className="mt-4 flex items-center space-x-2">
                <input
                  type="text"
                  name="aiMessage"
                  placeholder="Type your message..."
                  className="flex-1 px-4 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary text-sm"
                  disabled
                />
                <Button variant="default" size="icon" disabled>
                  <Icon name="Send" size={16} />
                </Button>
              </div>
            </div>
            
            <div className="absolute -top-4 -right-4 bg-success text-success-foreground px-4 py-2 rounded-lg shadow-lg">
              <div className="flex items-center space-x-2">
                <Icon name="TrendingUp" size={16} />
                <span className="text-sm font-semibold">90% Faster Response</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;